module.exports = "/_next/static/images/e4a80496ae39565895ccbfe87e812972-hero-lg.jpg";